import { render, staticRenderFns } from "./Delegation.vue?vue&type=template&id=7254dd7c"
import script from "./Delegation.vue?vue&type=script&lang=js"
export * from "./Delegation.vue?vue&type=script&lang=js"
import style0 from "./Delegation.vue?vue&type=style&index=0&id=7254dd7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports